import React, { ReactNode } from "react";
import styled from "styled-components";

import { colors } from "src/styles";

export interface TableRowProps {
  $clickable: boolean;
  children: ReactNode;
  onClick: () => void;
  $bgColor?: string;
  $appearance?: "modern" | "legacy";
}

const TableRow = ({
  $clickable: clickable,
  children,
  onClick,
  $bgColor = colors.white.default,
  $appearance = "modern",
}: TableRowProps) => {
  return (
    <TableRowComponent $appearance={$appearance} $bgColor={$bgColor} onClick={onClick} $clickable={clickable}>
      {children}
    </TableRowComponent>
  );
};

export default TableRow;

const TableRowComponent = styled.tr<TableRowProps>`
  font-style: normal;
  font-size: ${(props: TableRowProps) => (props.$appearance === "legacy" ? "14px" : "13px")};
  background-color: ${(props: TableRowProps) => props.$bgColor};
  ${(props: TableRowProps) => props.$clickable && `cursor: pointer;`};

  ${(props: TableRowProps) =>
    props.$appearance === "legacy"
      ? `
    &:nth-child(odd) {
      background-color: ${colors.grey.light6};
    }
  `
      : `
    &:hover {
      background-color: ${props.$clickable ? colors.grey.light6 : props.$bgColor};
    }
  `}
`;
